import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MaterialModule } from 'src/app/material.module';
import { MainPagosComponent } from './main-pagos/main-pagos.component';
import { AgregarPagosComponent } from './agregar-pagos/agregar-pagos.component';
import { ListaPagosComponent } from './lista-pagos/lista-pagos.component';

@NgModule({
  declarations: [
    MainPagosComponent,
    AgregarPagosComponent,
    ListaPagosComponent
  
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
  ],
  providers: [
  ],
  exports: [
    MainPagosComponent,
    AgregarPagosComponent,
    ListaPagosComponent
   


  ]
})
export class PagosModule { }
